import * as types from "../actions/types";

const initialState = {
  loading: false,
  error: null,
  dashboard: null,
  campaigns: { items: [], total: 0, page: 1, page_size: 25, total_pages: 0 },
  currentCampaign: null,
  templates: [],
  currentTemplate: null,
  contacts: { items: [], total: 0, page: 1, page_size: 25, total_pages: 0 },
  currentContact: null,
  segments: [],
  sequences: [],
  allSequences: { items: [], total: 0, page: 1, page_size: 25, total_pages: 0 },
  automations: [],
  scoringRules: [],
  whatsappLogs: { items: [], total: 0, page: 1, page_size: 25, total_pages: 0 },
  campaignStats: null,
  campaignFunnel: null,
  campaignSends: { items: [], total: 0, page: 1, page_size: 50, total_pages: 0 },
  timeline: { items: [], total: 0, page: 1, page_size: 50, total_pages: 0 },
  imports: [],
  organizations: { items: [], total: 0, page: 1, page_size: 25, total_pages: 0 },
  currentOrganization: null,
  orgTasks: [],
  orgActivity: { items: [], total: 0, page: 1, page_size: 20, total_pages: 0 },
  pipeline: { items: [], total: 0, summary: {}, page: 1, page_size: 50, total_pages: 0 },
  upcomingTasks: [],
};

const marketingReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.MARKETING_SET_LOADING:
      return { ...state, loading: action.payload };
    case types.MARKETING_SET_ERROR:
      return { ...state, error: action.payload };
    case types.MARKETING_SET_DASHBOARD:
      return { ...state, dashboard: action.payload };
    case types.MARKETING_SET_CAMPAIGNS:
      return { ...state, campaigns: action.payload };
    case types.MARKETING_SET_CURRENT_CAMPAIGN:
      return { ...state, currentCampaign: action.payload };
    case types.MARKETING_SET_TEMPLATES:
      return { ...state, templates: action.payload };
    case types.MARKETING_SET_CURRENT_TEMPLATE:
      return { ...state, currentTemplate: action.payload };
    case types.MARKETING_SET_CONTACTS:
      return { ...state, contacts: action.payload };
    case types.MARKETING_SET_CURRENT_CONTACT:
      return { ...state, currentContact: action.payload };
    case types.MARKETING_UPDATE_CONTACT_IN_LIST:
      return {
        ...state,
        contacts: {
          ...state.contacts,
          items: state.contacts.items.map((c) =>
            c.id === action.payload.id ? { ...c, ...action.payload } : c
          ),
        },
      };
    case types.MARKETING_SET_SEGMENTS:
      return { ...state, segments: action.payload };
    case types.MARKETING_SET_SEQUENCES:
      return { ...state, sequences: action.payload };
    case types.MARKETING_SET_ALL_SEQUENCES:
      return { ...state, allSequences: action.payload };
    case types.MARKETING_SET_AUTOMATIONS:
      return { ...state, automations: action.payload };
    case types.MARKETING_SET_SCORING_RULES:
      return { ...state, scoringRules: action.payload };
    case types.MARKETING_SET_WHATSAPP_LOGS:
      return { ...state, whatsappLogs: action.payload };
    case types.MARKETING_SET_CAMPAIGN_STATS:
      return { ...state, campaignStats: action.payload };
    case types.MARKETING_SET_CAMPAIGN_FUNNEL:
      return { ...state, campaignFunnel: action.payload };
    case types.MARKETING_SET_CAMPAIGN_SENDS:
      return { ...state, campaignSends: action.payload };
    case types.MARKETING_SET_TIMELINE:
      return { ...state, timeline: action.payload };
    case types.MARKETING_SET_IMPORTS:
      return { ...state, imports: action.payload };
    case types.MARKETING_SET_ORGANIZATIONS:
      return { ...state, organizations: action.payload };
    case types.MARKETING_SET_CURRENT_ORGANIZATION:
      return { ...state, currentOrganization: action.payload };
    case types.MARKETING_SET_ORG_TASKS:
      return { ...state, orgTasks: action.payload };
    case types.MARKETING_SET_ORG_ACTIVITY:
      return { ...state, orgActivity: action.payload };
    case types.MARKETING_SET_PIPELINE:
      return { ...state, pipeline: action.payload };
    case types.MARKETING_SET_UPCOMING_TASKS:
      return { ...state, upcomingTasks: action.payload };
    default:
      return state;
  }
};

export default marketingReducer;
